import { render, staticRenderFns } from "./ProjectManager.vue?vue&type=template&id=6552a686&"
import script from "./ProjectManager.vue?vue&type=script&lang=js&"
export * from "./ProjectManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports